import Cookies from 'js-cookie'
import Vue from 'vue'
import Vuex from 'vuex'
import { systemModule } from './system/SystemStore'
import { itemModule } from './items/ItemStore'
import { authModule } from './auth/AuthStore'
import { dialogModule } from './components/DialogStore'
import { pdfDesignModule } from './pdfDesign/PdfDesignStore'
import { adminUserModule } from './admin/AdminUserStore'
import { adminGrupoModule } from './admin/AdminGrupoStore'
import { adminDashboardModule } from './admin/AdminDashboardStore'
import { adminItensRankingModule } from './admin/AdminItensRankingStore'
import { adminLogModule } from './admin/AdminLogStore'
import { adminAuditoriaModule } from './admin/AdminAuditoriaStore'
import { adminIntegracaoModule } from './admin/AdminIntegracaoStore'
import { adminAcessoRestritoModule } from './admin/AdminAcessoRestritoStore'
import { adminCatalogoModule } from './admin/AdminCatalogoStore'
import { catalogoModule } from './catalogo/CatalogoStore'
import { clienteModule } from './cliente/ClienteStore'
import { vendedorModule } from './vendedor/VendedorStore'
Vue.use(Vuex)

const theme = Cookies.get('theme') ?? 'light'

export default new Vuex.Store({
  // strict é opção SOMENTE do store raiz: declarada dentro de um módulo ela é
  // silenciosamente ignorada. Só em dev — faz deep-watch síncrono da árvore
  // inteira a cada mutation.
  strict: process.env.NODE_ENV !== 'production',
  state: {
    theme: theme,
  },
  mutations: {
    SET_THEME(state, payload) {
      state.theme = payload
      Cookies.set('theme', payload, { expires: 365 })
    },
  },
  actions: {
    setTheme({ commit }, payload) {
      commit('SET_THEME', payload)
    },
  },
  getters: {
    theme: (state) => state.theme,
  },
  modules: { systemModule, itemModule, authModule, dialogModule, pdfDesignModule, adminUserModule, adminGrupoModule, adminDashboardModule, adminItensRankingModule, adminLogModule, adminAuditoriaModule, adminIntegracaoModule, adminAcessoRestritoModule, adminCatalogoModule, catalogoModule, clienteModule, vendedorModule },
})
